import { useLocation } from 'react-router-dom';
import { COLORS, WALLET_COLORS as C } from '@/constants';

type Translate = (key: string) => string;
type WalletHeaderProps = {
  t: Translate;
  onMenu: () => void;
  onConnect?: () => void;
  connectLabel?: string;
  title?: string;
};

import { MenuIcon } from './WalletShared';

const HEADER_TITLE_KEYS: Record<string, string> = {
  wallet: 'menu.home',
  trading: 'menu.uo_trading',
  me: 'menu.my_uo',
  'ep-hub': 'menu.ep_trading',
  'ep-trading': 'menu.ep_trading',
  'ep-buy': 'menu.ep_trading',
  'ep-sell': 'menu.ep_trading',
};

export function WalletHeader({ t, onMenu, onConnect, connectLabel, title }: WalletHeaderProps) {
  const { pathname } = useLocation();
  const routeKey = pathname.replace(/^\//, '').split('/')[0] || 'wallet';
  const titleKey = HEADER_TITLE_KEYS[routeKey] ?? 'auth.orbTitle';
  const headerTitle = title ?? t(titleKey);
  const connectText = connectLabel ?? t('auth.connectWallet');

  return (
    <header className="fixed left-1/2 top-0 z-50 flex h-[65px] w-full max-w-[430px] -translate-x-1/2 items-start justify-between px-5 pt-[35px]" style={{ background: COLORS.topbarBg}}>
      <button type="button" aria-label={t('common.menu')} onClick={onMenu} className="flex size-[30px] items-center justify-center"><MenuIcon /></button>
      <div className="flex items-center justify-center gap-1">
        <img src="/orbit.png" alt="" className="size-8 object-cover" draggable={false} />
        <div className="flex align-center gap-1 text-base font-semibold leading-none">
          <span className="bg-clip-text text-transparent" style={{ backgroundImage: C.logoText }}>ORB</span>
          <span style={{ color: COLORS.iconGlobal }}>{headerTitle}</span>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {onConnect ? (
          <button
            type="button"
            aria-label={connectText}
            onClick={onConnect}
            className="max-w-[52px] truncate text-[10px] font-semibold leading-none"
            style={{ color: COLORS.selectedText }}
          >
            {connectText}
          </button>
        ) : (
          <div className="size-[30px]" aria-hidden />
        )}
      </div>
    </header>
  );
}
